// removed by extract-text-webpack-plugin
module.exports = {"container":"InstructionsContent-module-container-3Chgf","title":"InstructionsContent-module-title-LSCoj","item":"InstructionsContent-module-item-3Sc2t","short-description":"InstructionsContent-module-short-description-2rFam","shortDescription":"InstructionsContent-module-short-description-2rFam","body-list":"InstructionsContent-module-body-list-3C6w_","bodyList":"InstructionsContent-module-body-list-3C6w_"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/FittingInstructions/components/InstructionsContent/InstructionsContent.module.scss
// module id = 1298
// module chunks = 0